import { useEffect, useState } from "react";
import {
	Overlay,
	StyledModal,
	ModalHeader,
	ModalTitle,
	CloseButton,
	SaveButton,
} from "../styles/StyledPresetModal";
import { CustomSelect } from "../styles/CustomSelect";
import LabeledInput from "./LabeledInput";
import { PresetObj } from "../types/general-types";

export function PresetModal({
	handleSaveNewPreset,
	presets,
}: {
	handleSaveNewPreset: (presetName: string, presetSection: string) => void;
	presets: PresetObj[][];
}) {
	const [presetName, setPresetName] = useState<string>("");
	const [presetSection, setPresetSection] = useState<string>("custom");
	const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);
	const [presetSections, setPresetSections] = useState<any[]>([]);

	const handleSelectChange = (selectedOption: any) => {
		if (selectedOption.__isNew__) {
			// If the option is new, add it to the presetSections state
			setPresetSections((prevState) => [...prevState, selectedOption]);
		}
		setPresetSection(selectedOption.value);
	};

	const handleCreate = (inputValue: string) => {
		// create new category object
		const newOption = { value: inputValue, label: inputValue };
		// add new category to presetSections
		setPresetSections((prevState) => [...prevState, newOption]);
		// set new category as the selected category
		setPresetSection(inputValue);
	};

	const buildPresetSections = () => {
		let res: any[] = [];
		for (let i = 0; i < presets.length; i++) {
			let obj = { value: presets[i][0].section, label: presets[i][0].section };
			if (
				!res.includes(presets[i][0].section) &&
				presets[i][0].isStandard === false
			) {
				res.push(obj);
			}
		}
		setPresetSections(res);
	};

	useEffect(() => {
		buildPresetSections();
	}, []);

	return (
		<Overlay>
			<StyledModal>
				<ModalHeader>
					<ModalTitle>Add Preset</ModalTitle>
					<CloseButton onClick={() => handleSaveNewPreset("", "")}>
						&#x2716;
					</CloseButton>
				</ModalHeader>
				<div className="flex flex-col gap-1">
					<span className="text-xs text-highlight2">Preset Section</span>
					<CustomSelect
						value={presetSections.find(
							(option) => option.value === presetSection
						)}
						onChange={handleSelectChange}
						onCreateOption={handleCreate}
						options={presetSections}
						menuIsOpen={menuIsOpen}
						setMenuIsOpen={setMenuIsOpen}
					/>
				</div>
				<LabeledInput
					label="Preset Name"
					value={presetName}
					onChange={(e) => setPresetName(e.target.value)}
					isVisible={true}
					type="text"
				/>

				<div className="flex mt-1">
					<SaveButton
						type="button"
						onClick={() => handleSaveNewPreset(presetName, presetSection)}
					>
						Save
					</SaveButton>
				</div>
			</StyledModal>
		</Overlay>
	);
}
